@if (!showChart) {
  <div
    class="d-flex align-items-center justify-content-center w-100 h-100 mb-0 alert alert-info text-center">
    <div>
      <span class="fa-solid fa-circle-info mr-2"></span>
      <span translate>No Data available. Please check the chart configuration.</span>
    </div>
  </div>
}


@if (showChart) {
  <highcharts-chart
    [oneToOne]="oneToOneFlag"
    [constructorType]="chartConstructor"
    [options]="chartOptions"
    [(update)]="updateFlag"
    (chartInstance)="onChartInstance($event)"
    class="highchart-chart">
  </highcharts-chart>
}
